import { render, staticRenderFns } from "./BulkReports.vue?vue&type=template&id=a7198134"
import script from "./BulkReports.vue?vue&type=script&lang=js"
export * from "./BulkReports.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports